<template>
  <v-autocomplete
    :disabled="disabled"
    :item-text="optionConfig.label"
    :item-value="optionConfig.entityAttributeName"
    :items="itemList"
    :rules="ruleList"
    outlined
    v-model="value"
  ></v-autocomplete>
</template>

<script>
import formElementMixin from "./formElementMixin";
import selectReferenceMixin from "./selectReferenceMixin";

export default {
  mixins: [formElementMixin, selectReferenceMixin],
};
</script>
